import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { axiosInstance } from "../utils/AxiosInstance";

const BASE_URL = process.env.REACT_APP_BASE_URL;

export const fetchDashboardData = createAsyncThunk(
  "dashboard/fetchDashboardData",
  async () => {
    try {
      const response = await axiosInstance.get(`${BASE_URL}/dashboard`);
      console.log(response.data);
      return response.data.data;
    } catch (error) {
      console.log(error);
    }
  }
);

const initialState = {
  loading: false,
  organizations: [],
  applications: [],
  users: [],
  subscriptions: [],
};

const dashboardSlice = createSlice({
  name: "dashboard",
  initialState,
  extraReducers: (builder) => {
    builder
      .addCase(fetchDashboardData.pending, (state, action) => {
        state.loading = true;
      })
      .addCase(fetchDashboardData.fulfilled, (state, action) => {
        state.loading = false;
        state.organizations = action.payload.organizations;
        state.applications = action.payload.applications;
        state.users = action.payload.users;
        state.subscriptions = action.payload.subscriptions;
      })
      .addCase(fetchDashboardData.rejected, (state, action) => {
        state.loading = false;
      });
  },
});

export default dashboardSlice.reducer;
